import * as services from 'services/espectacularesActas';
import { showAlert } from './alert.actions';

export const getCatalogIdINEByEdo = (data) => async (dispatch) => {
  try {
    const response = await services.idInes(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

export const updateMonitoreo = (data) => async () => {
  try {
    const response = await services.updateHallazgo(data);
    console.log('REspuesta upsert', response);
    return { success: true, response };
  } catch (error) {
    return { success: false, response: error };
  }
};
